import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminSearchInquiries } from '@api/adminInquiries';
import { IAdminInquiriesTableData, IAdminSearchInquiriesProps } from '@interfaces/adminInquiries';

import { buildAdminInquiryListPayload } from './utils';

export const handleGetAdminInquiryList = createAsyncThunk<
  AxiosResponse<IAdminInquiriesTableData>,
  IAdminSearchInquiriesProps
>('getAdminInquiryList', props => adminSearchInquiries(buildAdminInquiryListPayload(props)));
